import React from "react";
import Image from "../../components/image";

export const VIOptionCard = ({
  iconImg,
  fallbackIcon,
  title,
  logoFallbackImage,
  description,
  bgLogoImage,
  containerClass = "relative bg-black-lighter dark:bg-gray-standard gvi-box-shadow rounded-xs h-80 md:h-48 mt-14 sm:mt-0",
  iconContainerClass = "absolute left-1/2 top-0 z-10 md:left-0 md:top-1/2 -translate-x-1/2 -translate-y-1/2 flex justify-center items-center w-[74px] md:w-[88px] h-[74px] md:h-[88px] rounded-full bg-white dark:bg-gray-darker gvi-box-shadow",
  contentContainer = "pt-14 pb-5 px-6 md:py-6 md:px-[75px] text-center md:text-left",
  contentInnerContainer = "flex flex-col md:flex-row justify-center md:justify-start pb-2",
  titleClass = "text-white font-semibold font-body pb-5 md:pb-0 md:pr-6",
  dividerClass = "w-1/5 md:w-auto md:h-auto border-b md:border-b-0 md:border-r border-white mx-auto",
  dividerImageContainerClass = "pt-5 md:pt-0 md:pl-6 w-full md:w-3/5 object-contain md:flex-shrink-0 mx-auto",
  dividerImageClass = "md:h-16 2xl:h-24 w-full",
  descriptionClass = "text-white dark:text-gray-generic"
}) => {
  return (
    <div className={containerClass}>
      <div className={iconContainerClass}>
        <Image
          imageAlt={title}
          image={iconImg}
          imageClass=""
          sourceUrl={fallbackIcon}
        />
      </div>
      <div className={contentContainer}>
        <div className={contentInnerContainer}>
          <h3
            className={titleClass}
            dangerouslySetInnerHTML={{ __html: title }}
          />

          {logoFallbackImage && (
            <>
              <div className={dividerClass} />
              <div className={dividerImageContainerClass}>
                <Image
                  imageAlt={title}
                  image={""}
                  imageClass={dividerImageClass}
                  sourceUrl={bgLogoImage ?? logoFallbackImage}
                />
              </div>
            </>
          )}
        </div>
        <div
          className={descriptionClass}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};
